import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import constant from 'src/app/app.constant';
import { CommonHttpService } from 'src/app/utils/common-http.service';
import { LocalStorageService } from 'src/app/utils/local-storage.service';

@Component({
  selector: 'app-ds-attendance-view',
  templateUrl: './ds-attendance-view.component.html',
  styleUrls: ['./ds-attendance-view.component.scss']
})
export class DsAttendanceViewComponent implements OnInit {
  vendorList: any;
  deliveryBoyList: any;
  public customizer: boolean = false;
  public constant: any = constant;
  dailyDeploymentList: any = [];
  dailyDeploymentPagination: any;
  currentPage: number = 1;
  beforeDate: any = moment().format(constant.DateFormatHtml);
  fromDate: any = this.beforeDate;
  toDate: any = this.beforeDate;
  @Input() dsAttendance: any;

  datePickerConfig = {
    format: constant.DateFormat,
    disableKeypress: true,
    drops: 'down',
    closeOnSelect: true,
    closeOnSelectDelay: 100,
    openOnFocus: false,
    max: moment().format(constant.DateFormat)
  };
  datePickerConfig1: any = {
    format: constant.DateFormat,
    disableKeypress: true,
    closeOnSelect: true,
    drops: 'down',
    closeOnSelectDelay: 100,
    max: moment().format(constant.DateFormat)
  };
  constructor(public activeModal: NgbActiveModal, private http: CommonHttpService, private localData: LocalStorageService) { }

  ngOnInit() {
    if (this.dsAttendance) {
      let currentDateTime = moment().add().format(constant.DateFormat);
      this.fromDate = this.dsAttendance.fromDate ? moment(this.dsAttendance.fromDate, constant.DateFormatServerSideDate).format(constant.DateFormat) : moment(currentDateTime, constant.DateFormat).format(constant.DateFormat);
      this.toDate = this.dsAttendance.toDate ? moment(this.dsAttendance.toDate, constant.DateFormatServerSideDate).format(constant.DateFormat) : moment(currentDateTime, constant.DateFormat).format(constant.DateFormat);
      this.getOneDailyDeploymentList();
    }
  }
  loadPage(page: number) {
    this.currentPage = page
    this.getOneDailyDeploymentList();
  }
  getOneDailyDeploymentList() {
    let reqData = {
      fromDate: this.fromDate,
      toDate: this.toDate,
      delivery_staff_id: (this.dsAttendance.delivery_staff_id) ? ([this.dsAttendance.delivery_staff_id]) : null,
      vendor_user_id: (this.dsAttendance.vendor_user_id) ? ([this.dsAttendance.vendor_user_id]) : null
    }
    if (reqData.fromDate) reqData.fromDate = moment(reqData.fromDate, constant.DateFormat).format(constant.DateFormatServerSideDate);
    if (reqData.toDate) reqData.toDate = moment(reqData.toDate, constant.DateFormat).format(constant.DateFormatServerSideDate);
    this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryStaff.GetByOneDailyDeployment + '?page=' + this.currentPage, reqData).subscribe((response: any) => {
      this.dailyDeploymentList = response.data;
      this.dailyDeploymentPagination = response.pagination;
      this.dailyDeploymentList.map((item: any) => {
        item.start_date_time = moment(item.start_date_time, constant.DateFormatServerSideWithDateTime).format('LT');
        item.end_date_time = moment(item.end_date_time, constant.DateFormatServerSideWithDateTime).format('LT');
      })
      // this.fromDate = this.dsAttendance?.fromDate
      // this.toDate = this.dsAttendance?.toDate
    })
  }

  Customizer() {
    this.customizer = !this.customizer;
  }

  onFormSave() {
    this.getOneDailyDeploymentList();
    this.customizer = false;
  }

  closeModal() {
    this.activeModal.dismiss();
  }

}
